// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import {
  spacing,
  fontSize,
  fontWeight,
  borderRadius,
} from 'presentations/views/styles';
import {
  primary,
  white,
  blue01,
  background,
  whiteFix,
} from 'presentations/views/styles/color';
import Icon from 'presentations/views/components/atoms/Icon';
import Link from 'presentations/views/components/atoms/Link';
import { macAppStorePath, downloadsPath } from 'presentations/routes/path';

interface Props {
  title?: string;
  className?: string;
  link?: string;
  platform?: 'apple' | 'android';
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const link = props.link || downloadsPath();
  const target = link === downloadsPath() ? undefined : '_blank';
  return (
    <Container className={props.className}>
      <Button href={link} target={target} rel={target && 'noopener'}>
        {props.platform && <StoreIcon name={`logo-${props.platform}`} />}
        <DownloadLabel>{props.title || t('Download')}</DownloadLabel>
      </Button>
    </Container>
  );
}

export const Container = styled.div`
  display: inline-block;
  border-radius: ${borderRadius(6)};
  /* border: 1px solid ${primary}; */
  background-color: ${primary};
  font-size: ${fontSize(14)};
  line-height: 1;
  :hover {
    /* background-color: ${blue01}; */
  }
`;
export const DownloadLabel = styled.span`
  font-size: ${fontSize(14)};
  letter-spacing: -0.02em;
  color: ${whiteFix};
`;
export const StoreIcon = styled(Icon)`
  width: 24px !important;
  height: 24px !important;
  padding-right: 4px;
  color: ${whiteFix};
`;
export const Button = styled(Link)`
  display: flex;
  align-items: center;
  font-weight: ${fontWeight('bold')};
  padding: ${spacing(8)} ${spacing(12)};
`;
